import { RestrictedAPI } from '@fnol/library/src/api';
import * as endpoints from './endpoints';

type GenericObject = { [key: string]: any };
export const getCountries = () => RestrictedAPI.get(endpoints.countries());
export const getCities = () => RestrictedAPI.get(endpoints.cities());
export const getPolicyDetails = (data: any) => RestrictedAPI.post(endpoints.policyDetails(), data);
export const getVehicleTypes = () => RestrictedAPI.get(endpoints.vehicleTypes());
export const getLeasingEntities = () => RestrictedAPI.get(endpoints.leasingEntities());
export const getPersonRoles = () => RestrictedAPI.get(endpoints.personRoles());
export const getPersonRelations = () => RestrictedAPI.get(endpoints.personRelations());
export const getIndustrialClassifications = () => RestrictedAPI.get(endpoints.industrialClassifications());
export const getClaimConfirmation = (data: any) => RestrictedAPI.post(endpoints.claimConfirmation(), data);
export const getClaimConfirmationAnonymous = (data: any) =>
    RestrictedAPI.post(endpoints.claimConfirmationAnonymous(), data);
export const sendOneTimePassword = (data: any) => RestrictedAPI.post(endpoints.oneTimePassword(), data);
export const getDocList = (id: string) => RestrictedAPI.get(endpoints.documents(id));
export const submitDocuments = (data: any) => RestrictedAPI.post(endpoints.addDocuments(), data);
export const submitTemporaryData = (data: GenericObject) => RestrictedAPI.post(endpoints.claimSubmit(), data);
